class HotelsCalculator {
  constructor() {
    this.initializeElements();
    this.bindEvents();
    this.loadStoredValues();
  }

  initializeElements() {
    this.form = document.getElementById("calcForm");
    this.hotelRoomsNum = document.getElementById("hotelRoomsNum");
    this.roomKeepersNum = document.getElementById("roomKeepersNum");
    this.roomKeepersRate = document.getElementById("roomKeepersRate");
    this.flatSheets = document.getElementById("flat");
    this.withRubberSheets = document.getElementById("withRubber");
    this.savingsResults = document.querySelector(".savingsResults");
  }

  bindEvents() {
    this.form.addEventListener("submit", (e) => this.handleSubmit(e));
    window.addEventListener("beforeunload", () => this.removeHotelsStorage());
  }

  loadStoredValues() {
    document.addEventListener("DOMContentLoaded", () => {
      const stored = localStorage.getItem("hotelsForm");
      if (!stored) return;

      const data = JSON.parse(stored);
      if (data.hotelRoomsNum > 0) {
        this.hotelRoomsNum.value = data.hotelRoomsNum;
        this.roomKeepersNum.value = data.roomKeepersNum;
        this.roomKeepersRate.value = data.roomKeepersRate;
        if (data.sheetsType === "flat") {
          this.flatSheets.checked = true;
        } else {
          this.withRubberSheets.checked = true;
        }
        document.getElementById("submit").click();
      }
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.toggleResults();
    this.showLoader();
    setTimeout(() => this.calculateResults(), 2500);
  }

  toggleResults() {
    if (this.savingsResults.style.display === "block") {
      this.savingsResults.style.display = "none";
    }
  }

  showLoader() {
    const loader = '<div class="lds-ripple"><div></div><div></div></div>';
    this.form.insertAdjacentHTML("afterend", loader);
  }

  calculateResults() {
    const config = this.getConfig();
    const results = this.performCalculations(config);
    this.displayResults(results, config);
    this.saveToLocalStorage();
  }

  getConfig() {
    return {
      usd: window.Shopify?.locale === "he" ? 1 : 3.4,
      sign: window.Shopify?.locale === "he" ? ' ש"ח' : " USD",
      timeUnit: window.Shopify?.locale === "he" ? " שעות" : " Hours",
      avgSalary:
        this.roomKeepersRate.value ||
        (window.Shopify?.locale === "he" ? 30 : 15),
      sheetsType: this.getSheetsType(),
    };
  }

  getSheetsType() {
    const sheetsTypes = document.getElementsByName("sheetsType");
    return Array.from(sheetsTypes).find((type) => type.checked)?.value;
  }

  performCalculations(config) {
    const { sheetsNum, timeNum } = this.getSheetsConfig();
    const moneySaved = 120 * 3.5 * sheetsNum * this.hotelRoomsNum.value;
    const timeSaved = 365 * timeNum * 0.7 * this.hotelRoomsNum.value;
    const timeToMoney = Math.round((timeSaved / 60) * config.avgSalary);

    return {
      moneySaved: Math.round(moneySaved / config.usd),
      timeSaved: Math.round(timeSaved / 60),
      timeToMoney,
      totalSavings: Math.round(moneySaved / config.usd) + timeToMoney,
      riskSaved: (this.roomKeepersNum.value / 30).toFixed(1),
    };
  }

  getSheetsConfig() {
    return this.getSheetsType() === "flat"
      ? { sheetsNum: 0.15, timeNum: 1.5 }
      : { sheetsNum: 0.06, timeNum: 0.5 };
  }

  displayResults(results, config) {
    const elements = {
      moneySavedPerYear: results.moneySaved + config.sign,
      timeSavedPerYear: `${results.timeSaved}${config.timeUnit} / ${results.timeToMoney}${config.sign}`,
      totalSavings: results.totalSavings + config.sign,
      roomKeepersRiskSavedPerYear: results.riskSaved,
    };

    Object.entries(elements).forEach(([id, value]) => {
      const element = document.getElementById(id);
      if (element) {
        element.textContent = this.numberWithCommas(value);
      }
    });

    document.querySelector(".lds-ripple").style.display = "none";
    this.savingsResults.style.display = "block";
    document.querySelector(".index-section.hotels-contact-form").style.display =
      "block";
  }

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  saveToLocalStorage() {
    const data = {
      hotelRoomsNum: this.hotelRoomsNum.value,
      roomKeepersNum: this.roomKeepersNum.value,
      roomKeepersRate: this.roomKeepersRate.value,
      sheetsType: this.getSheetsType(),
    };
    localStorage.setItem("hotelsForm", JSON.stringify(data));
  }

  removeHotelsStorage() {
    localStorage.removeItem("hotelsForm");
  }
}

// Initialize calculator when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  new HotelsCalculator();
});
